<template>
  <nav class="navbar">
    <div class="logo">
      <router-link :to="'/'">
        <img class="logo-img" src="/static/img/BVF-logo.svg" alt="logo" />
        <p class="logo-text">Bob Vlake Foundation</p>
      </router-link>
    </div>
    <ul class="nav-links">
      <li>
        <router-link :to="'/'">Home</router-link>
      </li>
      <li>
        <router-link :to="'/about'">Over ons</router-link>
      </li>
      <li>
        <router-link :to="'/projects'">Projecten</router-link>
      </li>
      <li>
        <router-link :to="'/contact'">Contact</router-link>
      </li>
    </ul>
    <div class="burger" @click="burgerAction">
      <div class="line1"></div>
      <div class="line2"></div>
      <div class="line3"></div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    burgerAction: function() {
      const burger = document.querySelector(".burger");
      const nav = document.querySelector(".nav-links");
      const navLinks = document.querySelectorAll(".nav-links li");

      nav.classList.toggle("nav-active");

      navLinks.forEach((link, idx) => {
        if (link.style.animation) {
          link.style.animation = "";
        } else {
          link.style.animation = `linkFade 0.5s ease forwards ${idx / 7 + 1.5}`;
        }
      });

      burger.classList.toggle("active");
    }
  }
};
</script>

<style lang="less" scoped>
@main-color: #2f660f;

.navbar {
  position: fixed;
  display: flex;
  width: 100%; //calc(100% - 15px);
  overflow-x: hidden;
  justify-content: space-around;
  align-items: center;
  height: 70px;
  top: 0;
  left: 0;
  z-index: 4;
  background-color: @main-color;
  // padding: 0 16px;
}

.logo {
  color: rgb(226, 226, 226);
  text-transform: uppercase;
  letter-spacing: 5px;
  font-size: 1.2rem;
  display: flex;
  height: 50px;
  width: 300px;
  padding: 6px;

  a {
    display: contents;
    height: 100%;

    p.logo-text {
      vertical-align: middle;
      width: auto;
      line-break: auto;
      margin: auto;
      font-size: 14px;
      text-decoration: none;
    }

    img {
      height: 100%;
      margin-right: 4px;
    }
  }
}

.nav-links {
  list-style: none;
  display: flex;
  justify-content: space-around;
  width: 350px;
  margin: 0;
  padding: 0;

  li a {
    color: rgb(226, 226, 226);
    text-decoration: none;
    letter-spacing: 3px;
    font-weight: bold;
    font-size: 14px;
  }
}

a {
  color: rgb(226, 226, 226);
  text-decoration: none;
}

.burger {
  display: none;

  div {
    width: 25px;
    height: 3px;
    background-color: rgb(226, 226, 226);
    margin: 5px;
    transition: all 0.3s ease;
  }

  &.active {
    .line1 {
      transform: rotate(-45deg) translate(-5px, 6px);
    }
    .line2 {
      opacity: 0;
    }
    .line3 {
      transform: rotate(45deg) translate(-5px, -6px);
    }
  }
}

@media screen and (max-width: 768px) {
  .burger {
    display: block;
    cursor: pointer;
  }
  .nav-links {
    position: fixed;
    right: 0;
    height: calc(100vh - 70px);
    top: 70px;
    background: @main-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60%;
    transform: translateX(100%);
    transition: transform 0.5s ease-in;
    z-index: 3;

    li {
      opacity: 1;
    }
  }
  .nav-active {
    transform: translateX(0%);
  }
}

@keyframes linkFade {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media print {
  .navbar {
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue